var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_826_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_827_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_828_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_829_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_830_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_831_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_832_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_833_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_834_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_850_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_851_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_852_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_853_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_854_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_855_",
    cx: 256,
    cy: 256,
    fill: "#5c4f5e",
    r: 256
  })))))))))))))))), /*#__PURE__*/React.createElement("path", {
    d: "m511.446 272.656-195.461-195.461-152.566 110.119 133.467 133.467-96.461 30.461s-137.087-24.932-137.934-25.568l186.217 186.216c2.423.068 4.853.11 7.292.11 135.787 0 246.862-105.724 255.446-239.344z",
    fill: "#403842"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m290.618 59.338c-12.098-4.148-25.165-3.868-36.794.79-10.597 4.244-19.755 11.949-26.824 22.495-7.069-10.546-16.227-18.251-26.823-22.495-11.629-4.658-24.697-4.937-36.794-.79-23.005 7.889-44.241 33.135-36.502 69.923 2.918 13.87 9.97 27.801 20.959 41.404 8.659 10.719 19.783 21.275 33.063 31.376 22.497 17.111 43.182 26.905 44.051 27.314l2.046.961 2.046-.961c.87-.409 21.554-10.202 44.051-27.314 13.28-10.101 24.404-20.657 33.064-31.376 10.989-13.603 18.041-27.533 20.959-41.404 7.739-36.787-13.497-62.033-36.502-69.923z",
    fill: "#ff735c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m327.12 129.26c-2.92 13.87-9.97 27.8-20.96 41.4-8.66 10.72-19.78 21.28-33.06 31.38-22.5 17.11-43.18 26.91-44.05 27.31l-2.05.97v-147.7c7.07-10.54 16.23-18.25 26.82-22.49 11.63-4.66 24.7-4.94 36.8-.79 23 7.89 44.24 33.13 36.5 69.92z",
    fill: "#fc435f"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m173.607 322.365-69.41-52.177c-15.317-11.514-37.068-8.436-48.588 6.877-11.527 15.322-8.445 37.088 6.882 48.608l59.157 44.461c20.243 15.229 44.887 23.464 70.219 23.464h185.244v-69.577z",
    fill: "#fcc78d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m377.111 329.482v-36.947l-34.14-.283c-12.267-.102-24.35-3.005-35.324-8.489-6.15-3.073-12.931-4.673-19.806-4.673h-100.287c-13.915 0-25.196 11.281-25.196 25.196 0 13.915 11.281 25.196 25.196 25.196z",
    fill: "#ffdba9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.547 263.222h101.709v149.359h-101.709z",
    fill: "#14c4a2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m324.55 329.48h101.71v83.1h-101.71z",
    fill: "#02a082"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.27fceac8b0eda07ce11219e5a684249b.svg";
export { ForwardRef as ReactComponent };